import PageTemplate from "../components/common/PageTemplate";
import ProductDetail from "../screen/purchase/product/ProductDetail";

const PurchaseProductPage = () => {
  return (
    <>
      <PageTemplate mainComponent={<ProductDetail />} />
    </>
  );
};

export default PurchaseProductPage;
